export let SearchPlaceholder = "LzD7wb";
export let SearchAriaLabel = "$LUmge";
export let SearchWithCopilotPlaceholder = "TS_yvc";
export default {SearchPlaceholder,SearchAriaLabel,SearchWithCopilotPlaceholder};